import Handsontable from 'handsontable';
import { NUMBRO_CURRENCY, NUMBRO_CULTURE } from './constants';
import { textTooltipRenderer, numericTooltipRenderer } from './tooltipRenderer';

type NumbroFormat = {
  thousandSeparated?: boolean;
  mantissa?: number;
  trimMantissa?: boolean;
  optionalMantissa?: boolean;
  spaceSeparated?: boolean;
  average?: boolean;
  totalLength?: number;
};

interface NumericOptions {
  pattern?: string | NumbroFormat;
  culture?: string;
  readOnly?: boolean;
  align?: 'htLeft' | 'htCenter' | 'htRight';
  validator?: Handsontable.ColumnSettings['validator'];
  enableTooltip?: boolean;
}

export function createNumericColumn(overrides: NumericOptions = {}): Handsontable.ColumnSettings {
  const {
    pattern = NUMBRO_CURRENCY,
    culture = NUMBRO_CULTURE,
    readOnly = false,
    align = 'htCenter',
    validator,
    enableTooltip = true
  } = overrides;
  return {
    type: 'numeric',
    numericFormat: { 
      pattern, 
      culture 
    },
    className: align,
    readOnly,
    validator,
    ...(enableTooltip && { renderer: numericTooltipRenderer })
  };
}

interface TextOptions {
  readOnly?: boolean;
  align?: 'htLeft' | 'htCenter' | 'htRight';
  enableTooltip?: boolean;
}

export function createTextColumn(overrides: TextOptions = {}): Handsontable.ColumnSettings {
  const { readOnly = false, align = 'htLeft', enableTooltip = true } = overrides;
  return { 
    type: 'text', 
    readOnly, 
    className: align,
    ...(enableTooltip && { renderer: textTooltipRenderer })
  };
}

interface DropdownOptions {
  source: string[];
  strict?: boolean;
  allowInvalid?: boolean;
  readOnly?: boolean;
  align?: 'htLeft' | 'htCenter' | 'htRight';
  enableTooltip?: boolean;
}

export function createDropdownColumn({ 
  source, 
  strict = true, 
  allowInvalid = false, 
  readOnly = false, 
  align = 'htLeft',
  enableTooltip = true
}: DropdownOptions): Handsontable.ColumnSettings {
  return {
    type: 'dropdown',
    source,
    strict,
    allowInvalid,
    readOnly,
    className: align,
    ...(enableTooltip && { renderer: textTooltipRenderer })
  };
}



